import * as ActionTypes from "../ActionTypes.js";
import { toast } from "react-toastify";
import { getClaims } from "../actions/ClaimActions.js";
import { getUsers } from "../actions/UserActions.js";
import { getServerDomain, toastOptions } from "utils";

export const loginUser = (dispatch, history, creds) => {
  fetch(getServerDomain() + "/users/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(creds),
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: ActionTypes.LOGIN_USER, payload: response.user });
      localStorage.setItem("token", response.token);
      localStorage.setItem("creds", JSON.stringify(response.user));
      history.push("/");
      toast.success("Logged in successfully!", toastOptions);
      getUsers(dispatch);
      getClaims(dispatch);
    })
    .catch((error) => {
      console.log("Login ", error.message);
      toast.error("Login Failed. " + error.message, toastOptions);
    });
};

export const logoutUser = (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("creds");
  dispatch({ type: ActionTypes.LOGOUT_USER });
  toast.success("Logged out successfully!", toastOptions);
};

export const signupUser = (dispatch, history, formData) => {
  fetch(getServerDomain() + "/users/signup", {
    method: "POST",
    body: formData,
    credentials: "include",
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error("Signup Failed. " + response.err, toastOptions);
      } else {
        dispatch({ type: ActionTypes.LOGIN_USER, payload: response.user });
        localStorage.setItem("token", response.token);
        localStorage.setItem("creds", JSON.stringify(response.user));
        history.push("/");
        toast.success("Signed up successfully!", toastOptions);
      }
    })
    .catch((error) => {
      console.log("Signup ", error.message);
      toast.error("Signup Failed. " + error.message, toastOptions);
    });
};

export const editUser = (dispatch, history, formData) => {
  fetch(getServerDomain() + "/users/edit", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    body: formData,
    credentials: "include",
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error("Profile update failed. " + response.err, toastOptions);
      } else {
        history.push("/");
        toast.success("Profile updated!", toastOptions);
        dispatch({ type: ActionTypes.LOGIN_USER, payload: response.user });
        localStorage.setItem("token", response.token);
        localStorage.setItem("creds", JSON.stringify(response));
      }
    })
    .catch((error) => {
      console.log("Profile update ", error.message);
      console.log("Profile update ", error.stack);
      toast.error("Profile update failed. " + error.message, toastOptions);
    });
};
